import { useMemo } from "react";

import { buildIdentitySectionModel } from "./IdentitySection/identitySectionModel";
import {
  useIdentityInspector,
  useIdentityManifestHistory,
  useIdentityReport,
} from "./IdentityWorkbench/identityWorkbenchApi";
import { selectedManifest } from "./IdentityWorkbench/identityWorkbenchModels";

export function useDirectorViewIdentityReport(args: {
  sessionId: string;
  summary: unknown;
  availabilityHint?: string | null;
  manifestStatusHint?: string | null;
  enabled: boolean;
}) {
  const sectionModel = useMemo(
    () =>
      buildIdentitySectionModel(args.summary, {
        availabilityHint: args.availabilityHint,
        manifestStatusHint: args.manifestStatusHint,
      }),
    [args.summary, args.availabilityHint, args.manifestStatusHint],
  );
  const hasIdentities = sectionModel.visibleSubjects.length > 0;
  const history = useIdentityManifestHistory(
    args.sessionId,
    args.enabled && hasIdentities,
  );
  const manifest = useMemo(
    () => selectedManifest(history.data?.data ?? [], null),
    [history.data],
  );
  const firstIdentityId = manifest?.subjects[0]?.echo_identity_id ?? null;
  const inspectorRequest =
    args.enabled &&
    manifest?.manifest_version != null &&
    manifest.identity_run_id &&
    firstIdentityId
      ? {
          sessionId: args.sessionId,
          identityId: firstIdentityId,
          manifestVersion: manifest.manifest_version,
          identityRunId: manifest.identity_run_id,
        }
      : null;
  const inspector = useIdentityInspector(inspectorRequest, 0);
  const reportArtifact =
    inspector.data?.artifacts.find(
      (artifact) => artifact.kind === "identity_report",
    ) ?? null;
  const reportExpected =
    reportArtifact &&
    manifest?.manifest_version != null &&
    manifest.manifest_digest &&
    manifest.identity_run_id
      ? {
          sessionId: args.sessionId,
          manifestVersion: manifest.manifest_version,
          manifestDigest: manifest.manifest_digest,
          identityRunId: manifest.identity_run_id,
        }
      : null;
  const report = useIdentityReport(reportArtifact, reportExpected, 0);

  return {
    report: report.data ?? null,
    mode: sectionModel.summary?.mode ?? null,
  };
}
